<div class="col-12" *ngIf="!isLoading">
    <app-grid #grid [domLayout]="'normal'" [rowData]="rowData" [rowHeight]="40" rowSelection="single"
      (selectionChangedEvent)="onSelectionChanged($event)" [columnDefs]="columnDefs" [pagination]="true"
      (refreshEvent)="getData()">
    </app-grid>
</div>

<app-loading class="mt-2 flex align-items-center justify-content-center" *ngIf="isLoading"></app-loading>